import { render } from "./ManagementFlagsBlock.vue?vue&type=template&id=81123b88&scoped=true"
import script from "./ManagementFlagsBlock.vue?vue&type=script&lang=js"
export * from "./ManagementFlagsBlock.vue?vue&type=script&lang=js"

import "./ManagementFlagsBlock.vue?vue&type=style&index=0&id=81123b88&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81123b88"]])

export default __exports__